export default function Alert(theme) {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(1.5, 2),
        },
        standard: {
          backgroundColor: theme.palette.background.paper,
        },
        filled: {
          fontWeight: 500,
        },
        outlined: {
          borderWidth: 1.5,
        },
        icon: {
          fontSize: '1.25rem',
        },
        message: {
          padding: 0,
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          marginBottom: theme.spacing(0.5),
        },
      },
    },
  };
}

